import {
    request,
    requestPublic
} from './request.js'
// 文章列表
// 获取文章列表
export function getPage(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/Article/GetPage',
        method: 'get',
        params: {
            CategoryOneId: obj.categoryOneId,
            CategoryId: obj.categoryId,
            Title: obj.title,
            Isjd: obj.isjd,
            Istj: obj.istj,
            Ispl: obj.ispl,
            Source: obj.source,
            ChannelId: obj.channelId,
            ArticleContent: obj.articleContent,
            RelevanceType: obj.relevanceType,
            Keyword: obj.keyword,
            pageIndex: obj.pageIndex,
            pageSize: obj.pageSize,
        }
    })
}

//添加
export function addArticle(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Article/Add',
        method: 'post',
        data: data
    })
}

//获取文章详情
export function getDetali(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Article/Get',
        method: 'get',
        params: {
            id: id
        }
    })
}
//编辑
export function editArticle(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Article/Edit',
        method: 'post',
        data: data
    })
}
//批量删除
export function deletesArticle(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Article/Deletes',
        method: 'post',
        data: data
    })
}

//获取专题类型
export function getAllSpecialTopicTypes() {
    return request({
        url: '/api2/ZsbSiteAdmin/SpecialTopic/GetAllSpecialTopicTypes',
        method: 'get'
    })
}
//获取全部专题
export function getAllSpecialTopics(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/SpecialTopic/GetAllSpecialTopics',
        method: 'post',
        data: data
    })
}
// 获取文章关联专题
export function getArticleRelevance(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Article/GetArticleRelevance',
        method: 'get',
        params: {
            id: id
        }
    })
}
// 发布文章
export function ArticleHtml(oldId) {
    return request({
        url: '/api2/ZsbSiteAdmin/HtmlRelease/ArticleHtml?oldId=' + oldId,
        method: 'post',
    })
}